<template>
  <div class="aerial-view">
    <div class="banner">
      <div class="banner-box">
        <div class="banner-text">
          <div class="slogan animate__animated animate__fadeInLeftBig">专为科技金融打造的智能决策引擎</div>

          <div class="title animate__animated animate__fadeInLeftBig">瞰见</div>

          <div class="sub-title animate__animated animate__fadeInLeftBig">
            中知独创产业智能体与区域智能体，通过对产业链、产业集群、区域政策及科创资源等多维数据的深度挖掘，<br />
            透视产业全景、洞察区域特色，为产业选择到区域差异化经营提供决策依据。<br />
          </div>

          <div class="tags-container animate__animated animate__fadeInLeftBig">
            <span v-for="(tag, index) in tags" :key="index">{{ tag }}</span>
          </div>

          <div class="dimension-container animate__animated animate__fadeInLeftBig">
            <span class="dimension-title">多维数据支撑</span>
            <div class="dimension-content">
              <div class="dimension-item" v-for="(item, index) in dimensionList" :key="index">
                <i class="iconfont icon-gouxuan-mianxing"></i>
                <span>{{ item }}</span>
              </div>
            </div>
          </div>

          <div class="btn-container animate__animated animate__fadeInUp">
            <div class="exp-btn" @click="toRegister">
              <span>申请体验</span>
              <i class="iconfont icon-youjiantou-xianxing"></i>
            </div>
          </div>
        </div>

        <div class="banner-card animate__animated animate__fadeInRightBig">
          <div class="card-item" v-for="(item, index) in cardList" :key="index" :style="{ backgroundImage: `url(${item.bgUrl})` }">
            <div class="card-title">
              <img :src="item.iconUrl" alt="">
              <span>{{ item.title }}</span>
            </div>
            <div class="card-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'AerialViewV2',
  computed: {
    ...mapState(['isLogin'])
  },
  data () {
    return {
      tags: ['产业图谱', '区域洞察', '链式分析', '差异决策'],
      dimensionList: ['国家知识产权局全量权威数据', '产业数据', '科创数据', '人才数据', '区域政策'],
      cardList: [
        {
          title: '产业全景透视',
          desc: '自动绘制产业链图谱，识别强链、补链、卡脖子关键节点，预判产业景气度与演进趋势',
          iconUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_产业全景透视.png',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_产业全景透视.png'
        },
        {
          title: '区域多维评估',
          desc: '透视区域产业集群格局，量化地方政策支持力度与科创资源禀赋，定位高潜力赛道与核心承载区',
          iconUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_区域多维评估.png',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_区域多维评估.png'
        },
        {
          title: '宏观逐层穿透',
          desc: '从产业到区域、从区域到企业逐层穿透，在区域产业演进中把握机遇',
          iconUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_宏观逐层穿透.png',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_宏观逐层穿透.png'
        }
      ]
    }
  },
  methods: {
    toRegister () {
      this.$router.push('/register')
      window.scrollTo(0, 0, 'smooth')
    }
  }
}
</script>
<style lang='scss' scoped>
.aerial-view {
  .banner {
    width: 100%;
    min-width: $container-width;
    height: Translate(690px);
    background: url("https://images.zzt.com.cn/cdn_file/zst-official/bg_瞰见.png") no-repeat;
    background-position: center center;
    background-size: cover;
    margin: 0 auto;

    &-box {
      width: $container-width;
      margin: 0 auto;
      position: relative;
      height: 100%;
    }

    &-text {
      text-align: left;

      .slogan {
        position: absolute;
        top: Translate(58px);
        left: 0;
        @include Slogan();
      }

      .title {
        position: absolute;
        top: Translate(90px);
        left: 0;
        @include Text(60px, 500, 82px, #111, 'AlibabaPuHuiTiB');
      }

      .sub-title {
        width: Translate(680px);
        position: absolute;
        top: Translate(172px);
        left: 0;
        @include Text(14px, 400, 24px, #333333, 'PingFangSC-Regular');
      }

      .tags-container {
        position: absolute;
        top: Translate(234px);
        left: 0;
        display: flex;
        flex-wrap: wrap;
        gap: Translate(8px);

        span {
          @include Tag();
        }
      }

      .dimension-container {
        position: absolute;
        top: Translate(320px);
        left: 0;
        @include DimensionContainer();

        .dimension-title {
          @include Text(18px, 600, 24px, #111111, 'PingFangSC-Semibold');
        }

        .dimension-content {
          display: flex;
          flex-wrap: wrap;
          gap: Translate(8px) Translate(20px);
          margin-top: Translate(23px);

          .dimension-item {
            display: flex;
            align-items: center;
            gap: Translate(4px);

            i {
              font-size: Translate(14px);
              color: #91BAFF;
            }

            span {
              @include Text(14px, 400, 20px, #333333, 'PingFangSC-Regular');
            }
          }
        }
      }

      .btn-container {
        position: absolute;
        top: Translate(494px);
        left: 0;
        display: flex;
        justify-content: space-between;

        .exp-btn {
          @include Button(180px, 60px, transparent, 16px, #fff);
          background-image: linear-gradient(90deg, #0058FF 0%, #12A4FA 100%);
          border-radius: Translate(30px);
          transition: all 0.15s ease-in;

          &:hover {
            opacity: 0.8;
            transform: translateY(Translate(-4px));
            box-shadow: 4px 10px 30px -4px rgba(0, 88, 255, 0.4);
          }

          i {
            font-size: Translate(22px);
            margin-left: Translate(6px);
            transition: transform 0.15s ease-in;
            @include ChevronIconAnimation();
          }
        }
      }
    }

    &-card {
      position: absolute;
      top: Translate(58px);
      right: 0;
      text-align: left;
      display: flex;
      flex-direction: column;
      gap: Translate(18px);

      .card-item {
        width: Translate(340px);
        height: Translate(120px);
        padding: Translate(20px);
        background-size: 100% 100%;
        box-sizing: border-box;
        border-radius: Translate(8px);
        transition: all 0.3s ease-in;

        &:hover {
          transform: translateY(Translate(-2px));
          box-shadow: 0 4px 8px 0 rgba(166, 166, 166, 0.1);
        }

        .card-title {
          display: flex;
          align-items: center;
          gap: Translate(6px);
          @include Text(18px, 600, 25px, #111111, 'PingFangSC-Semibold');

          img {
            width: Translate(18px);
            height: Translate(18px);
          }
        }

        .card-desc {
          margin-top: Translate(4px);
          @include Text(14px, 400, 24px, #333333, 'PingFangSC-Regular');
        }
      }
    }
  }
}
</style>
